import { render, staticRenderFns } from "./EntityObjectInfo.vue?vue&type=template&id=45f53b2c&scoped=true"
import script from "./EntityObjectInfo.vue?vue&type=script&lang=js"
export * from "./EntityObjectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f53b2c",
  null
  
)

export default component.exports